import type { ComponentType } from "react";
import {
  Home,
  Calendar,
  Clock,
  HelpCircle,
  UserCircle,
  MessageSquare,
  UserPlus,
  BarChart3,
  UserRoundCog,
} from "lucide-react";

export interface NavItemConfig {
  path: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  exact?: boolean;
  demoOnly?: boolean;
  hideInDemo?: boolean;
  dataTour?: string;
}

/**
 * Admin bottom nav items - ordered by priority.
 * First maxVisible items shown as tabs, rest in "Więcej" overflow.
 */
export const NAV_ITEMS: NavItemConfig[] = [
  { path: "/dashboard", label: "Home", icon: Home },
  { path: "/schedules", label: "Grafiki", icon: Calendar },
  { path: "/chat", label: "Czat", icon: MessageSquare },
  { path: "/employees", label: "Pracownicy", icon: UserPlus },
  { path: "/timesheet", label: "Czas pracy", icon: Clock },
  { path: "/reports", label: "Raporty", icon: BarChart3 },
  { path: "/substitutions", label: "Zastępstwa", icon: UserRoundCog },
  { path: "/profile", label: "Profil", icon: UserCircle },
  { path: "/help", label: "Pomoc", icon: HelpCircle, hideInDemo: true },
  { path: "/demo-help", label: "Pomoc", icon: HelpCircle, demoOnly: true },
];

export function filterNavItems(
  items: NavItemConfig[],
  isDemoMode: boolean
): NavItemConfig[] {
  return items.filter((item) => {
    if (isDemoMode && item.hideInDemo) return false;
    if (!isDemoMode && item.demoOnly) return false;
    return true;
  });
}
